module.exports = __webpack_public_path__ + "img/icon-very-dissatisfied.699dbb1.svg";